import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import Layout from '../Layout';
import RouteNames from './RouteNames';
import ProtectedRoute from '../components/Fragments/ProtectedRoute';
import Login from '../components/Login/LoginController';
import Register from '../components/Register/RegisterController';
import ForgotPassword from '../components/ForgotPassword/ForgotPasswordController';
import Profile from '../components/Profile/ProfileController';
import B2bProfile from '../components/B2bProfile/B2bProfileController';
import NotFoundView from '../components/NotFound/NotFoundView';

const RouteProvider = () => (
    <BrowserRouter>
        <CookiesProvider>
            <Layout>
                <Switch>
                    <ProtectedRoute exact path={RouteNames.LOGIN} component={Login} />
                    <ProtectedRoute path={RouteNames.REGISTER} component={Register} />
                    <ProtectedRoute path={RouteNames.FORGOT_PASSWORD_B2B} component={ForgotPassword} />
                    <ProtectedRoute path={RouteNames.FORGOT_PASSWORD_B2C} component={ForgotPassword} />
                    <ProtectedRoute path={RouteNames.PROFILE} component={Profile} />
                    <ProtectedRoute path={`${RouteNames.PROFILE}/:key`} component={Profile} />
                    <ProtectedRoute path={RouteNames.B2B} component={B2bProfile} />
                    <ProtectedRoute path={`${RouteNames.B2B}/:key`} component={B2bProfile} />
                    <Route component={NotFoundView} />
                </Switch>
            </Layout>
        </CookiesProvider>
    </BrowserRouter>
);

export default RouteProvider;
